import React from 'react';
import ReactDOM from 'react-dom';
import Router from 'react-router-dom/BrowserRouter';
import { Provider } from 'react-redux'
import store from './store';
import 'react-dates/lib/css/_datepicker.css';
import 'react-quill/dist/quill.snow.css';
import './styles/bundle.scss';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';

window.moment = moment;
ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
